{
  "fr": {
    "decision": {
      "actions": {
        "add": "Ajouter",
        "addDocument": "Document",
        "addUnits": "Unités",
        "approve": "Approuver",
        "autoCloseAfterApproval": "Fermeture automatique après approbation",
        "autoCloseAfterApprovalInfo": "La décision se ferme lorsqu'une proposition est approuvée",
        "autoCloseAfterDeadline": "Fermeture automatique après le délai",
        "cancel": "Annuler",
        "changeResponsible": "Changer responsable",
        "clickToSetDeadline": "Cliquer pour fixer la date limite",
        "closeDecision": "Fermer décision",
        "confirmChoices": "Confirmer des choix",
        "createProposal": "Créer une proposition",
        "create_decisions": "Ajouter décision | Ajouter décisions",
        "delete": "Supprimer",
        "deleteCount": "Vous êtes sur le point de supprimer {count} décision. Êtes-vous sûr? | Vous êtes sur le point de supprimer {count} décisions. Êtes-vous sûr?",
        "deleteMultipleDecisions": "Supprimer...",
        "delete_cancel": "Annuler",
        "delete_decisions": "Supprimer décision | Supprimer décisions",
        "edit": "Modifier",
        "editBudget": "Modifier budget",
        "editDeadline": "Modifier date limite",
        "editDecision": "Modifier décision",
        "editReminders": "Modifier rappels",
        "goToProposal": "Aller à la proposition",
        "goToSummary": "Aller au résumé",
        "hide": "Dépublier",
        "hideInfo": "Masquer les informations",
        "noDescription": "Cliquer pour ajouter une description",
        "openDecision": "Décision ouverte",
        "publish": "Publier",
        "publishAll": "Pour tous",
        "publishCustomer": "Publier pour le client",
        "publishPartners": "Publier pour les partenaires",
        "reject": "Rejeter",
        "relaunch_decision": "Décision de relance",
        "request_changes": "Demander des modifications",
        "reset": "Reset",
        "save": "Enregistrer",
        "save_and_share_partners": "Sauvegarder et partager avec les partenaires",
        "selectAll": "Sélectionner toutes les {total} décisions",
        "selectChoices": "Sélectionner des choix",
        "share_proposals": "Partager des propositions",
        "showMoreInfo": "Afficher plus d'informations",
        "stopApproving": "Arrêter de sélectionner",
        "submit": "Enregistrer",
        "tickBoxesDeletion": "Cochez les cases des fichiers que vous souhaitez supprimer.",
        "unSelectAll": "Effacer la sélection.",
        "unpublishForCustomer": "Dépublier pour le client",
        "unpublishForPartners": "Depublier pour le partenaire de décision",
        "update": "Mettre à jour",
        "upload": "Télécharger",
        "upload_documents": "Télécharger documents",
        "upload_proposals": "Télécharger propositions"
      },
      "attributes": {
        "amount_gross": "Offre brute",
        "amount_net": "Offre nette",
        "approved_at": "Date d'approbation de la proposition",
        "approved_proposal_name": "Proposition approuvée",
        "bathrooms": "Nombre de salles de bain",
        "bedrooms": "Nombre de chambres",
        "category": "Catégorie",
        "customer_group_name": "Client",
        "decision_name": "Décision",
        "decisions_count": "{count} décision | {count} décisions",
        "due_date": "Date limite",
        "floor": "Étage",
        "negative_surcharges_allowed": "Autorisez la sous-facturation",
        "note_employee": "Note",
        "price_budget": "Budget",
        "price_budget_extra": "Budget supplémentaire",
        "price_budget_info": "Vous pouvez toujours modifier le budget plus tard",
        "price_budget_info_mup": "Vous pouvez toujours modifier le budget par unité plus tard",
        "price_margin": "Marge",
        "price_surcharge": "Supplément",
        "published": "Publiée",
        "responsible": "Responsable",
        "status": "Status",
        "unit": "Unité",
        "verification_type": "Décision d'approbation donnée par",
        "visibility": "Visibilité"
      },
      "edit_actions": {
        "edit_auto_close": "Options de fermeture automatique",
        "edit_close_decision": "Fermer/Ouvrir décision",
        "edit_deadline": "Date limite",
        "edit_margin": "Marges",
        "edit_negative_surcharges_allowed": "Autorisez la sous-facturation",
        "edit_note_employee": "Note",
        "edit_price_budget": "Budget",
        "edit_price_budget_extra": "Budget supplémentaire",
        "edit_reminders": "Rappels",
        "edit_responsible": "Responsable"
      },
      "labels": {
        "accessRights": "Les droits d'accès client",
        "activity": "Activité",
        "addDecisionNote": "Ajouter une note",
        "addReminders": "Ajouter des rappels",
        "allUnits": "Tous",
        "allUnitsAssigned": "Toutes les unités assignées",
        "allow_not_interested": "Autoriser l'option 'Pas intéressé'",
        "allow_not_interested_info": "Affiche une option 'Pas intéressé' à côté des propositions",
        "approved": "Approuvée",
        "approvedAt": "Approuvée {approved_at}",
        "approvedProposal": "Proposition approuvée",
        "askQuestion": "Posez ici vos questions concernant votre décision {decision}",
        "assignCustomerToUnit": "Assigner un client",
        "autoClose": "Fermeture automatique",
        "budgetOverview": "Aperçu du budget",
        "budgetSubtitle": "Entrez un budget ici s'il s'applique à toutes les unités sélectionnées",
        "budgetTitle": "Fixez un budget",
        "checkbox": "Case à cocher",
        "clickHereToChange": "Cliquez ici si vous voulez les changer.",
        "close": "Fermer",
        "closeDecision": "Fermer la décision",
        "closed": "La décision est fermée pour cette unité. Le client ne pourra plus approuver une proposition.",
        "closedLabel": "Décision fermée",
        "closed_tag": "Décision fermé",
        "closed_tooltip_customer": "La décision est clôturée. Vous ne pourrez plus approuver une proposition.",
        "countDocuments": "Pas encore de document | 1 document | {count} documents",
        "countEdit": "Modifier {count} décision | Modifier la décision pour {count} unités",
        "countUpload": "Télécharger documents dans cette unité | Télécharger documents dans {count} unités",
        "created_on": "Décision créée le {date}",
        "custom_columns_title": "Vous pouvez ajouter jusqu'à 10 colonnes",
        "customer": "Client",
        "customer_status": "Status client",
        "decided": "Décidée",
        "decision": "Décision",
        "decisionBreadcrumb": "Décision {decision_type}",
        "decisionNotPublishedYetFor": "Décision non encore publiée pour",
        "decisionNoteExplainer": "Cette note n'est visible que pour votre équipe et pour les partenaires qui ont accès à cette décision",
        "decisionType": "Sujet Décision",
        "decisionUnit": "Décision pour l'unité {unit}",
        "decisions": "Décisions",
        "decisions_all_projects": "Décisions tous les projets",
        "decisions_breadcrumb": "Décisions {project}",
        "default": "Défaut",
        "deleteExplanation": "Tous les messages de communication, fichiers, propositions et autres données seront définitivement supprimés de la plate-forme. Les clients et les fournisseurs liés à ces décisions perdront tout accès.",
        "descriptionSubtitle": "Ici, vous pouvez ajouter plus d'informations pour votre client",
        "descriptionTitle": "Ajouter une description",
        "documentRequired": "Document signé requis pour approbation",
        "documentUnits": "Dossier de l'unité",
        "documents": "Documents décision",
        "dueDate": "Date limite: {date}",
        "due_date_subtitle": "Fixer une date à laquelle la décision doit être prise",
        "due_date_title": "Date limite et rappels",
        "editDecisionNote": "Modifier la note",
        "extra_options": "Options supplémentaires",
        "false": "Non",
        "filter": "Filtre",
        "finalSettings": "Quelques réglages optionnels",
        "finalSettingsStep": "Réglages finaux",
        "financial": "Financier",
        "firstThingsfirst": "Tout d'abord, quelques informations générales",
        "follow": "Suivre",
        "following": "Suivi actif — vous recevrez des notifications",
        "four": "4",
        "giveNewAmount": "Donner le nouveau montant",
        "hideCount": "Dépublier cette décision pour 1 unité | Dépublier la décision pour {count} unités",
        "hideVisibilitySettings": "Masquer les paramètres de visibilité",
        "indicate_not_interested": "Indiquez que le client n'est pas intéressé par cette décision",
        "info": "Montrer plus d'info",
        "infoCustomers": "Coordonnées du client",
        "information": "Information",
        "make_a_decision": "Prendre une décision",
        "marginOnBudget": "Marge sur le budget (%)",
        "marginOnUpgrades": "Marge sur les suppléments (%)",
        "marginOnUpgradesExplainer": "La marge sur les suppléments sera également utilisée pour les budgets supplémentaires que vous accordez à un client. Le budget supplémentaire peut être fixé dans la décision d'une unité.",
        "marginOverview": "Aperçu des marges",
        "marginSubTitle": "Calculer les marges automatiquement en pourcentages",
        "marginTitle": "Utiliser des pourcentages de marge",
        "members": "Membres",
        "modifyLater": "Vous pouvez modifier ces paramètres ultérieurement",
        "name": "Nom",
        "newActivity": "Nouvelle activité",
        "newDocument": "Nouveau document",
        "next": "Suivant",
        "no": "Non",
        "noApprovedProposalYet": "Aucune proposition acceptée pour le moment",
        "noBudget": "Pas de budget défini",
        "noCustomer": "Pas encore de client",
        "noCustomerAssigned": "Aucun client assigné à l'unité pour le moment",
        "noDeadline": "Pas de date limite",
        "noDecisionDueDate": "Sélectionner une date limite",
        "noDecisionStartDate": "Aucune date de début",
        "noDecisionsMade": "Aucune décision prise pour l'instant.",
        "noDecisionsToMake": "Aucune décision à prendre.",
        "noDecisionsYet": "Aucune décision pour le moment",
        "noDocumentsShared": "Aucun document partagé",
        "noDueDate": "Fixer une date limite avant de définir des rappels",
        "noDueDateSet": "Pas de date limite",
        "noExtraBudget": "Pas de budget supplémentaire",
        "noMessages": "Écrivez votre premier message pour {decision} dans la case ci-dessous.",
        "noUnitDocuments": "Aucun document ajouté dans le dossier Unité",
        "noUnitsClick": "Pas encore d'unités pour ce projet, cliquez ici pour ajouter",
        "no_result_for_search": "Aucun résultat pour cette recherche filtrée.",
        "no_surcharges": "Sans suppléments",
        "no_surcharges_info": "Propositions sans suppléments financiers",
        "notDecided": "Pas encore décidé",
        "notDecidedYet": "Le client n'a pas encore pris de décision.",
        "notFollowing": "Non suivi — cliquez pour recevoir des notifications",
        "notPossibleToWriteMessageDeactivatedUnit": "Cette décision est liée à une unité désactivée. Écrire un nouveau message n'est plus possible.",
        "notPublished": "Non publié",
        "notPublishedCustomer": "Décision non encore publiée pour le client",
        "notPublishedPartners": "Décision non encore publiée pour les partenaires de décision",
        "notShared": "Non partagé",
        "not_interested": "Pas intéressé",
        "not_interested_customer": "Pas intéressé",
        "not_interested_customer_info": "Si vous n'êtes pas intéressé par cette décision, ou si cette décision n'est pas pertinente pour vous, veuillez cliquer ici pour l'indiquer.",
        "not_interested_modal": {
          "customer": {
            "body": "Veuillez fournir des commentaires supplémentaires sur les raisons pour lesquelles vous n'êtes pas intéressé par cette décision.",
            "title": "Je ne suis pas intéressé par cette décision"
          },
          "employee": {
            "body": "Veuillez fournir des commentaires supplémentaires expliquant pourquoi le client n'est pas intéressé par cette décision. Ce feedback sera également visible pour le client.",
            "title": "Le client n'est pas intéressé par cette décision"
          },
          "feedback": "Commentaire"
        },
        "one": "1",
        "open": "Ouvrir",
        "openDecisionInfo": "Cette décision est ouverte. Le client peut approuver les propositions.",
        "open_auto_close_deadline_unit": "Définir si la décision doit être clôturée automatiquement ou non lorsque la date limite est dépassée",
        "open_auto_close_unit": "Indiquer si la décision doit être clôturée automatiquement ou non lors de l'approbation ",
        "open_close_unit": "la décision pour 1 unité | la décision pour {unit_count} unités",
        "or": "où",
        "participants": "Participants",
        "partners": "Partenaires de décision",
        "pendingDecisions": "1 décision à prendre | {count} décisions à prendre",
        "priceBudget": "Budget",
        "priceBudgetExtra": "Budget supplémentaire",
        "proposal": "Propositions",
        "proposals": "Propositions | 1 proposition | {count} propositions",
        "publish?": "Sauvegarder et publier?",
        "publishNow?": "Publier maintenant?",
        "publishTopOfPage": "Vous pouvez publier cette décision en haut de cette page",
        "publishedCount": "Publier cette décision pour 1 unité | Publier la décision pour {count} unités",
        "publishedCustomer": "Décision publiée pour le client",
        "publishedCustomerPartners": "Décision publiée pour le client et les partenaires de décision",
        "publishedNone": "Pas encore publiée",
        "publishedPartners": "Décision publiée pour les partenaires de décision",
        "publishedSince": "Décision publiée depuis le {date}",
        "published_info": "Indique si toutes les unités ont été publiées pour le client et/ou les partenaires de décision",
        "remainOpen": "Rester ouvert",
        "reminders": "Rappels",
        "remindersCount": "1 rappel | {count} rappels",
        "reopenDecision": "Rouvrir la décision",
        "requiresDocumentVerification": "Nécessite un document signé pour approbation",
        "requiresNoDocumentVerification": "Aucun document signé requis pour approbation",
        "returnToTickets": "Retour",
        "rights": {
          "access_full": "Accès complet",
          "access_none": "Accès restreint",
          "access_semi": "Accès de base",
          "customer_show": "Sera en mesure de voir les informations client",
          "default": "Les partenaires de décision peuvent envoyer des messages, télécharger des documents et créer des propositions à <b> {client_name} </b> à tout moment. Ils ont également accès aux plans dans le dossier des documents de l'unité. Ci-dessous, vous pouvez modifier leurs droits de communication envers vos clients.",
          "document_customer": "Pourrait partager directement des documents avec le client.",
          "message_customer": "Pourrait envoyer des messages au client.",
          "proposal_customer": "Pourrait offrir directement des propositions au client."
        },
        "save?": "Enregistrer?",
        "saveExplainer": "Rendez cette décision visible pour vos clients? Ou enregistrez et publiez plus tard?",
        "select": "Sélectionner",
        "selectOneUnit": "Sélectionnez au moins 1 unité",
        "selectUnits": "Sélectionnez les unités",
        "select_units": "Sélectionner les unités",
        "selected": "{selected} unité sélectionnée. | {selected} unités sélectionnées.",
        "sharedWith": "Partager avec",
        "showDecisionsFor": "Montrer les décisions de",
        "show_all_units": "Afficher toutes les unités",
        "signOnline": "Tapez le nom pour confirmer (défaut)",
        "signUploadDocument": "Télécharger un document signé",
        "signedDocument": "Télécharger un document signé",
        "status": "Status",
        "statusExplained": "Que signifie chaque statut de décision?",
        "step2Subtitle": "Sélectionnez votre projet pour inclure toutes vos unités à la fois.",
        "step2Title": "Quelles unités doivent prendre une décision?",
        "step2TitleWithDecisionName": "Quelles unités doivent prendre une décision pour {decision_name}?",
        "subject": "Sujet",
        "summary": "Résumé",
        "surcharge_tooltip": "Il s'agit du supplément pour cette décision",
        "surcharges_total": "Améliorations : {total}",
        "surcharges_total_tooltip": "Il s'agit du nombre total d'améliorations pour toutes les unités disposant d'une amélioration",
        "three": "3",
        "tickets": "Conversations décision",
        "toBeDecided": "Est encore à décider",
        "toDecide": "Décider",
        "total": "Total",
        "totalSelected": "Toutes les {total} unités sont sélectionnées.",
        "true": "Oui",
        "two": "2",
        "type": "Type",
        "unitDecisionsWillBeShownHere": "Les décisions des unités seront affichées ici",
        "unitNotActivated": "Uniquement pour les unités activées",
        "unitSelected": "Pas d'unité | 1 unité | {count} unités",
        "unit_name": "Unité",
        "units": "Unités",
        "unpublish": "Non publiée",
        "unpublished": "Non publiée",
        "uploadDocument": "Télécharger les documents",
        "useMargins": "Activer les pourcentages de marge",
        "use_surcharges": "Utiliser les suppléments",
        "use_surcharges_info": "Définir un budget pour les suppléments",
        "validation_errors": "Il y a des problèmes avec cette proposition. Veuillez d'abord les résoudre, puis réessayer.",
        "waitingForClient": "En attente d'un client",
        "whatTheCustomerHasBought": "Ce que le client a acheté",
        "when": "Quand",
        "who": "Qui",
        "withAll": "Tous",
        "withClient": "Avec {client} seulement",
        "withCustomer": "Avec client",
        "withCustomerName": "Avec {customer}",
        "withPartners": "Seulement avec partenaires de décision",
        "yes": "Oui"
      },
      "legend": {
        "all": "Toutes les décisions",
        "approved": "Décidé",
        "approvedAfterDue": "Proposition approuvée après la date limite",
        "created": "Pas encore de proposition",
        "decisionApproved": "Proposition approuvée",
        "hasDecision": "Pas encore de proposition",
        "hasProposal": "Proposition téléchargée",
        "has_proposal": "A déterminer",
        "isExpired": "Date limite expirée, pas de proposition",
        "isExpiredHasProposal": "Date limite expirée, proposition téléchargée",
        "noDecision": "Unité exclue de la décision",
        "not_interested": "Pas intéressé",
        "other_decisions": "Autres décisions",
        "requested_changes": "Modifications demandées",
        "waiting_for_proposal": "En attente d'une proposition"
      },
      "navigation": {
        "backToDecisions": "Retour aux décisions"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "De nouvelles décisions viendront bientôt!",
            "title": "Préparez-vous à prendre une décision"
          },
          "no_documents": {
            "subtitle": "Vous trouverez ici tous les documents relatifs à cette décision",
            "title": "Télécharger des documents liés à la décision {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "À partir du moment où un client est affecté à cette unité, vous verrez les conversations ici",
              "title": "Vous trouverez ici toutes les conversations pour cette décision"
            }
          },
          "new": {
            "subtitle": "Attribuer une décision à plusieurs unités en une seule fois",
            "title": "Créez votre première décision"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Vous recevrez un email lorsqu'une nouvelle décision sera publiée.",
            "title": "Vous n'avez encore aucune décision"
          }
        }
      },
      "toasts": {
        "bulk_create": "Décision créée avec succès | Décisions créées avec succès",
        "bulk_delete": "Décision supprimée avec succès | Décisions supprimées avec succès",
        "bulk_update": "Décision mise à jour avec succès | Décisions mises à jour avec succès",
        "update": "Décision mise à jour avec succès"
      },
      "validation": {
        "amountRequired": "Montant requis",
        "cannotUpdatePrice": "Le budget ne peut pas être modifié car les traches de paiement basés sur cette décision ont été rendus visibles pour le client",
        "customer": {
          "need_not_interested_note": "Veuillez indiquer pourquoi vous n'êtes pas intéressé par cette décision"
        },
        "employee": {
          "need_not_interested_note": "Veuillez indiquer pourquoi le client n'est pas intéressé par cette décision."
        },
        "installmentsSent": "Certaines décisions sélectionnées ont des tranches de paiement visibles pour le client. Leur budget restera le même.",
        "mustBeZeroOrMore": "Doit être un nombre positif ou zéro",
        "needAttachment": "Téléchargez au moins un nouveau document ou sélectionnez-en un dans le dossier de l'unité",
        "needNumber": "Besoin d'un numéro (pax example 8400.5)",
        "needTitle": "Champs requis",
        "need_responsible": "Besoin d'un responsable",
        "priceBudgetNotNegative": "Le budget ne peut pas être un nombre négatif.",
        "responsibleRequired": "Responsable requis",
        "selectContactPerson": "Sélectionnez au moins 1 personne de contact"
      }
    }
  }
}
